import { render } from "./Nekrolog.vue?vue&type=template&id=bf3663b8"
import script from "./Nekrolog.vue?vue&type=script&lang=js"
export * from "./Nekrolog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__